import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import {
  FETCH_THANKYOU_FAILURE,
  FETCH_THANKYOU_RESPONSE,
  FETCH_THANKYOU_REQUEST,
  ThankyouActionTypes,
  ThankYouObj
} from '../types/Thankyou';

import { RootState } from '../store/configureStore';
import { getCustomerID, isAuthenticated } from '../helpers/functions';
import history from '../helpers/history';
import c from '../helpers/constants';
import { fetchPaybyLinkThankyou, fetchThankyouDetails } from '../api/ThankyouApi';

export function fetchThankyouRequest(): ThankyouActionTypes {
  return {
    type: FETCH_THANKYOU_REQUEST,
    payload: null,
  };
}

export function fetchThankyouResponse(
  Thankyou: ThankYouObj,
): ThankyouActionTypes {
  return {
    type: FETCH_THANKYOU_RESPONSE,
    payload: Thankyou,
  };
}

export function fetchThankyouFailure(): ThankyouActionTypes {
  return {
    type: FETCH_THANKYOU_FAILURE,
    payload: null,
  };
}



export const fetchThankyou = ( params : any ):
  ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch(fetchThankyouRequest());
   /* if (!isAuthenticated()) {
      try {
        history.push(c.APP_ROUTES.LOGIN);
      } catch (e) {
      }
    }
      */

    const asyncResp: any = await fetchThankyouDetails(params);

    if (asyncResp) {
      await dispatch(fetchThankyouResponse(asyncResp));
    } else {
      await dispatch(fetchThankyouFailure());
    }
  };


  export const fetchLinkThankyou = ( params : any ):
  ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch(fetchThankyouRequest());
 
    const asyncResp: any = await fetchPaybyLinkThankyou(params);

    if (asyncResp) {
      await dispatch(fetchThankyouResponse(asyncResp));
    } else {
      await dispatch(fetchThankyouFailure());
    }
  };